import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import {IDType} from 'utils/prop-types';

import CancelButton from './CancelButton';
import AbortButton from './AbortButton';

const Footer = ({value, onCancel, onAbort}) => (
    <Fragment>
        <CancelButton onClick={onCancel} />
        <AbortButton value={value} onClick={onAbort} />
    </Fragment>
);

Footer.propTypes = {
    value: IDType.isRequired,
    onAbort: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default Footer;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonAbortModal/Footer.js